const AUTH_SESSION_COOKIE = 'auth_session_token';
const CLIENT_INFO_STORAGE_KEY = 'book-an-appointment-client-information';

function parseJwt(token: string): { exp?: number } | null {
	try {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
		const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
		return JSON.parse(atob(padded));
	} catch {
		return null;
	}
}

function getAuthCookieValue(): string | null {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${AUTH_SESSION_COOKIE}=`);
	if (parts.length !== 2) return null;
	return decodeURIComponent(parts.pop()!.split(';')[0]);
}

export function getAuthToken(): string | null {
	try {
		return getAuthCookieValue();
	} catch {
		return null;
	}
}

export function isLoggedIn(): boolean {
	try {
		const token = getAuthCookieValue();
		if (!token) return false;
		const payload = parseJwt(token);
		if (!payload?.exp) return false;
		return Date.now() < payload.exp * 1000;
	} catch {
		return false;
	}
}

export function getLoggedInFirstName(): string | null {
	try {
		const raw = localStorage.getItem(CLIENT_INFO_STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		return (parsed?.state?.firstName as string) || null;
	} catch {
		return null;
	}
}
